// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDsySYyybh766ezO2o7GGERfD23Y4G_VE8",
    authDomain: "ariifu-ccc03.firebaseapp.com",
    projectId: "ariifu-ccc03",
    storageBucket: "ariifu-ccc03.appspot.com",
    messagingSenderId: "221538167953",
    appId: "1:221538167953:web:ef5c621eff4f9ce552a330",
    measurementId: "G-QB50ZTN39H"
  },
  recaptcha3SiteKey: '6LdWeKEcAAAAAGhHUu-an7ixpLVxJFbq0M3pQ-WG',
};

// export const environment = {
//   production: false,
//   firebaseConfig: {
//     apiKey: "AIzaSyARer39a0eBYDTRLbbzQQhPzbFyhf97AGs",
//     authDomain: "fir-ariifu.firebaseapp.com",
//     projectId: "fir-ariifu",
//     storageBucket: "fir-ariifu.appspot.com",
//     messagingSenderId: "108144193834",
//     appId: "1:108144193834:web:6a1f9e82371cd28040ae53",
//     measurementId: "G-L8PTZ2Z4YQ"
//   },
//   recaptcha3SiteKey: '6Ld4t_4gAAAAAKK9wZiiRl8AQa0FLruz0Inq1ljB',
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
